import { createMessaging } from "@/scripts/messaging/messaging";
import store from "@/store";
import { getPosthog } from "@/scripts/posthog";
import { PH_FEATURE_FLAG_AI_OPERATOR } from "@/scripts/posthogEvents";

export const extensionMessaging = createMessaging({
  targetOrigin: window.location.origin,
  sourceId: "dashboard",
  callback: () => {
    store.dispatch("browser/savePluginDetected");
  },
});

export const initializeExtensionMessaging = (() => {
  let listenerAdded = false; // Private variable

  return async () => {
    const posthog = await getPosthog();
    const isOperatorEnabled = posthog?.getFeatureFlag(
      PH_FEATURE_FLAG_AI_OPERATOR
    );

    if (isOperatorEnabled && !listenerAdded) {
      extensionMessaging.addListener((payload) => {
        if (
          payload.type === "OPERATOR_DASHBOARD_LINK_RESPONSE" &&
          payload.data
        ) {
          store.dispatch("browser/saveOperatorDashboardLink", payload.data);
        }
      });
      listenerAdded = true;
    }
  };
})();

initializeExtensionMessaging();

export default extensionMessaging;
